import { h, render, Component } from 'preact';

class TxrNavSubmenuCompany extends Component {
    state = {
    }
    render() {
        return (
            <div class="txr-nav-submenu company">
                <div class="submenu-mobile-back" onClick={() => this.props.onClose()}>
                    <img class="submenu-mobile-back__icon" src="/images/navigation/icon-arrow-nav.svg"></img>
                    <span class="submenu-mobile-back__text">Company</span>
                </div>
                <div class="txr-nav-submenu-content">
                    <div class="submenu-left">
                        <div class="submenu-menus">
                            <a class="submenu-item" href="/about">
                                <i class="submenu-item__image-icon fal fa-hand-peace"></i>
                                <div class="submenu-item__content">
                                    <div class="submenu-item__title">
                                    About Us
                                    </div>
                                </div>
                            </a>
                            <a class="submenu-item" href="/careers">
                                <i class="submenu-item__image-icon fal fa-briefcase"></i>
                                <div class="submenu-item__content">
                                    <div class="submenu-item__title">
                                    Careers
                                    </div>
                                </div>
                            </a>
                            <a class="submenu-item" href="/contact">
                                <i class="submenu-item__image-icon fal fa-message-lines"></i>
                                <div class="submenu-item__content">
                                    <div class="submenu-item__title">
                                    Contact Us
                                    </div>
                                </div>
                            </a>
                            <a class="submenu-item" href="/news">
                                <i class="submenu-item__image-icon fal fa-newspaper"></i>
                                <div class="submenu-item__content">
                                    <div class="submenu-item__title">
                                    News & Press
                                    </div>
                                </div>
                            </a>
                            <a class="submenu-item" href="/partners">
                                <i class="submenu-item__image-icon font19 fal fa-handshake"></i>
                                <div class="submenu-item__content">
                                    <div class="submenu-item__title">
                                    Partners
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="submenu-right">
                        <a class="champions-club" href="https://app.textrequest.com/app/champions-club" target="_blank">
                            <div class="champions-club__title">CHAMPIONS CLUB</div>
                            <div class="champions-club__text">Earn $250 for each<br/>successful referral.</div>
                            <a class="txr-angle__link">Make Your First Referral<i class="txr-angle__link-icon fal fa-angle-right"></i></a>
                        </a>
                        
                    </div>
                </div>
            </div>
        )
    }
}

export default TxrNavSubmenuCompany;